import { Divider, Grid, Paper } from "@mui/material";
import React from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import CustomButton from "../../components/CustomButton/Index";
import CustomInputField from "../../components/CustomInputField/Index";
import DashboardLayout from "../../layouts";
import offerStyles from "../../styles/pages/VisaCategory/index.style";
import axios from "axios";
import CustomTimeTable from "../../components/CustomTimeTable/Index";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import url from "../../API";
import DashboardHeader from "../../components/DashHeader/Index";
import ConfirmationDialog from "../../components/ConfirmationDialog/Index";
import CustomInputAndSelectField from "../../components/CustomInputAndSelectField/Index";
import JoditEditor from "jodit-react";
import { FiExternalLink } from "react-icons/fi";

export default function CareersPage() {
  const classes = offerStyles();
  const navigate = useNavigate();
  const token = localStorage.getItem("tkn");
  const formData = new FormData();
  const [state, setState] = React.useState({
    question: "",
    job_name: "",
    job_type: "",
    salary: "",
    employee_type: "",
    location: "",
    experience: "",
    qualification: "",
    searchText: "",
    job_description: "",
    isUpdate: false
  });
  const [careerList, setcareerList] = React.useState([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [deletefaqId, setDeletefaqId] = React.useState(null);

  function table() {
    axios
      .get(url + "careerpage/getallcareerpage", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        // Handle the response
        setcareerList(response.data.Career_Page);
        //console.log(response.data.Career_Page);
      })
      .catch(error => {
        // Handle errors
        //console.error("Error fetching data:", error);
      });
  }

  React.useEffect(() => {
    table();
  }, []);

  const handleDelete = idx => {
    setDeletefaqId(idx);
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleSaveVisaCategory = () => {
    axios
      .post(
        url + "careerpage/createcareerpage",
        {
          job_name: state.job_name,
          job_type: state.job_type,
          salary: state.salary,
          employee_type: state.employee_type,
          location: state.location,
          experience: state.experience,
          qualification: state.qualification,
          job_description: state.job_description
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}` // Example authorization header
          }
        }
      )
      .then(r => {
        if (r.data.status == 201) {
          toast.success("Created Sucessfully", {
            position: "top-center"
          });
          table();
          window.scrollTo({ top: 500, behavior: "smooth" });
        }
      })
      .catch(error => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      question: "",
      job_name: "",
      job_type: "",
      salary: "",
      employee_type: "",
      location: "",
      experience: "",
      qualification: "",
      searchText: "",
      job_description: "",
      isUpdate: false
    });
  };

  const handleVisaCategoryDelete = idx => {
    axios
      .post(
        url + "careerpage/deletecareerpage",
        {
          id: deletefaqId
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}` // Example authorization header
          }
        }
      )
      .then(r => {
        if (r.data.status == 200) {
          toast.success("Deleted Sucessfully", {
            position: "top-center"
          });
          setConfirmDialogOpen(false);
          table();
        }
      })
      .catch(error => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
  };

  const handleUpdateVisaCategory = idx => {
    axios
      .post(
        url + "careerpage/updatecareerpage",
        {
          id: idx,
          job_name: state.job_name,
          job_type: state.job_type,
          salary: state.salary,
          employee_type: state.employee_type,
          location: state.location,
          experience: state.experience,
          qualification: state.qualification,
          job_description: state.job_description
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}` // Example authorization header
          }
        }
      )
      .then(r => {
        if (r.data.status == 200) {
          toast.success("Updated Sucessfully", {
            position: "top-center"
          });
          table();
          window.scrollTo({ top: 500, behavior: "smooth" });
        }
      })
      .catch(error => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      question: "",
      job_name: "",
      job_type: "",
      salary: "",
      employee_type: "",
      location: "",
      experience: "",
      qualification: "",
      searchText: "",
      job_description: "",
      isUpdate: false
    });
  };

  return (
    <div className={classes.container}>
      <DashboardLayout />
      <div className={classes.contentSection}>
        <DashboardHeader />
        <Divider className={classes.divider} />
        <div
          className={classes.contentHead}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px"
            }}
          >
            {" "}<p style={{ marginTop: "2px", fontSize: "22px" }}>Careers</p>
          </div>
        </div>
        {/* <Divider className={classes.divider} /> */}
        <div className={classes.contentMain}>
          {/* <p className={classes.title}>Frequently Asked Questions</p> */}
          <Paper className={classes.paper}>
            <Grid container spacing={3} className="content" alignItems={"end"}>
              <Grid item xs={6}>
                <CustomInputField
                  label="Job Name"
                  fullWidth
                  value={state.job_name}
                  onChange={e =>
                    setState({
                      ...state,
                      job_name: e.target.value
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputAndSelectField
                  options={[
                    "Full-Time",
                    "Part-Time",
                    "Freelance",
                    "Contract",
                    "Temporary",
                    "Internship",
                    "Remote",
                    "Consultant",
                    "Shift Work"
                  ]}
                  value={state.job_type}
                  changeCallBack={(e, v) => {
                    //console.log(v);
                    setState({
                      ...state,
                      job_type: v
                    });
                  }}
                  label="Job Type"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputField
                  label="Salary (e.g. 100k - 200k)"
                  fullWidth
                  value={state.salary}
                  onChange={e =>
                    setState({
                      ...state,
                      salary: e.target.value
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputAndSelectField
                  options={[
                    "Permanent Employee",
                    "Temporary Employee",
                    "Seasonal Employee",
                    "Part-Time Employee",
                    "Full-Time Employee",
                    "Intern",
                    "Freelancer or Independent Contractor",
                    "On-Call Employee",
                    "Casual Employee",
                    "Apprentice"
                  ]}
                  value={state.employee_type}
                  changeCallBack={(e, v) => {
                    //console.log(v);
                    setState({
                      ...state,
                      employee_type: v
                    });
                  }}
                  label="Employee Type"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputField
                  label="Location"
                  fullWidth
                  value={state.location}
                  onChange={e =>
                    setState({
                      ...state,
                      location: e.target.value
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputField
                  label="Experience"
                  fullWidth
                  value={state.experience}
                  onChange={e =>
                    setState({
                      ...state,
                      experience: e.target.value
                    })}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomInputField
                  label="Qualification"
                  fullWidth
                  value={state.qualification}
                  onChange={e =>
                    setState({
                      ...state,
                      qualification: e.target.value
                    })}
                />
              </Grid>
              <Grid item xs={12}>
                Job Description
                {/* <Editor
                  label="Job Description"
                  editorState={state.job_description}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  // value={state.country_description}
                  onEditorStateChange={(e) =>
                    setState({
                      ...state,
                      job_description: e,
                    })
                  }
                /> */}
                <JoditEditor
                  value={state.job_description}
                  tabIndex={1} // tabIndex of textarea
                  onBlur={newContent =>
                    setState({
                      ...state,
                      job_description: newContent
                    })} // preferred to use only this option to update the content for performance reasons
                  onChange={newContent => {}}
                  config={{
                    placeholder: "" // Disable the placeholder text
                  }}
                />
              </Grid>
              {/* <Grid item xs={5}>
                <CustomInputField
                  type="File"
                  fullWidth
                  onChange={(e) =>
                    setState({
                      ...state,
                      visaImg: e.target.value,
                    })
                  }
                />
              </Grid> */}
              <Grid item xs={2} alignItems="end">
                {state.isUpdate
                  ? <CustomButton
                      text={"Update"}
                      variant="contained"
                      color="warning"
                      fullWidth
                      onClick={e => {
                        if (
                          !!state.job_name &&
                          !!state.job_type &&
                          !!state.salary &&
                          !!state.employee_type &&
                          !!state.location &&
                          !!state.experience &&
                          !!state.qualification &&
                          !!state.job_description
                        ) {
                          handleUpdateVisaCategory(state.id);
                        } else {
                          toast.error("Fill all the information", {
                            position: "top-center"
                          });
                        }
                      }}
                    />
                  : <CustomButton
                      text={"Create"}
                      variant="contained"
                      fullWidth
                      onClick={e => {
                        if (
                          !!state.job_name &&
                          !!state.job_type &&
                          !!state.salary &&
                          !!state.employee_type &&
                          !!state.location &&
                          !!state.experience &&
                          !!state.qualification &&
                          !!state.job_description
                        ) {
                          handleSaveVisaCategory();
                        } else {
                          toast.error("Fill all the information", {
                            position: "top-center"
                          });
                        }
                      }}
                    />}
              </Grid>
            </Grid>
            <ToastContainer />
          </Paper>
          <p className={classes.title}>Job List</p>
          <Paper className={classes.paper}>
            <CustomInputField
              label="Search..."
              fullWidth
              value={state.searchText}
              onChange={e =>
                setState({
                  ...state,
                  searchText: e.target.value
                })}
              className="searchField"
            />
            <CustomTimeTable
              fullWidth
              cols={["Sl No.", "Job Name", "Job Type", "Salary", "Action"]}
              rows={[
                ...careerList
                  .sort()
                  //   .filter((l) => {
                  //     const question = l.question?.toLowerCase() || "";
                  //     const answer =
                  //       JSON.parse(l.answer)?.blocks[0].text?.toLowerCase() || "";
                  //     const searchLower = (state.searchText || "").toLowerCase();
                  //     return (
                  //       question.includes(searchLower) ||
                  //       answer.includes(searchLower) ||
                  //       searchLower === undefined
                  //     );
                  //   })

                  .map((vs, idx) => [
                    idx + 1,
                    vs.job_name,
                    vs.job_type,
                    vs.salary,

                    <span className={classes.actionBtn}>
                      <CustomButton
                        variant="contained"
                        color="error"
                        onClick={e => handleDelete(vs.id)}
                        icon={<FaTimes />}
                      />
                      <CustomButton
                        variant="contained"
                        color="warning"
                        onClick={e => {
                          setState({
                            job_type: vs.job_type,
                            job_name: vs.job_name,
                            salary: vs.salary,
                            employee_type: vs.employee_type,
                            location: vs.location,
                            experience: vs.experience,
                            qualification: vs.qualification,
                            job_description: vs.job_description,
                            isUpdate: true,
                            id: vs.id
                          });
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        icon={<FaEdit />}
                      />
                      <CustomButton
                        variant="contained"
                        color="error"
                        onClick={e =>
                          navigate("/job-applicant-list", {
                            state: { slug: vs.job_slug }
                          })}
                        icon={<FiExternalLink />}
                      />
                    </span>
                  ])
              ]}
            />
          </Paper>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        onConfirm={handleVisaCategoryDelete}
      />
    </div>
  );
}
